<template>
	<!-- faq start -->
	<transition name="slide">
		<div
			v-if="show"
			class="faq_wrap"
			:style="this.heightCalc"
			style="display: block; overflow-y: auto;"
			tabindex="0"
			title="자주 묻는 질문"
		>
			<ul>
				<li v-for="(faq, index) in faqList" :key="index">
					<a href="#" @click="clickMessage(faq)">{{ faq }}</a>
				</li>
			</ul>
			<a
				href="#"
				class="btn_close_faq fas fa-times-circle"
				title="자주 묻는 질문 닫기"
				><span class="bg_clip">자주 묻는 질문 닫기</span></a
			>
		</div>
	</transition>
	<!--// faq end -->
</template>

<script>
import config from '../config/config.json';

export default {
	name: 'Faq',
	props: {
		userInfo: {
			type: Object,
			default: null,
			required: false,
		},
		show: {
			type: Boolean,
			default: true,
			required: false,
		},
		// 특정 서비스 중 버튼 disable
		chatActive: {
			type: Boolean,
			default: false,
			required: false,
		},
		// 질의 보낸 후 답변 오기전까지 전송 disable
		writingDisable: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	data() {
		return {
			faqList: [],
		};
	},
	mounted() {
		this.getFaqList();
		},

		computed: {
			heightCalc: function () {
 
				if (this.faqList.length <= 9) {
					let high = this.faqList.length * 50 + "px";
          return "height:" + high  ;
        }
				return "height:500px";
			},
		},


	methods: {
		getFaqList() {			
			this.$axios
				.post(config.REST_API_PATH + '/chat/faq', {
					agentName: this.userInfo.agentName,
					categoryName: config.FAQ_CATEGORY_NAME,
					repoId: this.userInfo.repoId,
					userId: this.userInfo.userId,
				})
				.then(response => {
					this.faqList = response.data.list;
				});
		},
		clickMessage(query) {
			if (!this.chatActive) {
				alert('사용자 정보를 등록할 때는 질문을 입력하실 수 없습니다.');
			} else if (this.writingDisable) {
				alert('이전 질문에 대한 답변을 처리중입니다.');
			} else {
				this.$emit('msgClick', query, query);
			}
		},
		close() {
			this.$emit('close');
		},
	},
};
</script>
<style scoped>
/* transition slide */
.slide-enter-active {
	-moz-transition-duration: 0.4s;
	-webkit-transition-duration: 0.4s;
	-o-transition-duration: 0.4s;
	transition-duration: 0.4s;
	-moz-transition-timing-function: ease-in;
	-webkit-transition-timing-function: ease-in;
	-o-transition-timing-function: ease-in;
	transition-timing-function: ease-in;
}

.slide-leave-active {
	-moz-transition-duration: 0.2s;
	-webkit-transition-duration: 0.2s;
	-o-transition-duration: 0.2s;
	transition-duration: 0.2s;
	-moz-transition-timing-function: cubic-bezier(0, 1, 0, 1);
	-webkit-transition-timing-function: cubic-bezier(0, 1, 0, 1);
	-o-transition-timing-function: cubic-bezier(0, 1, 0, 1);
	transition-timing-function: cubic-bezier(0, 1, 0, 1);
}

.slide-enter-to,
.slide-leave {
	max-height: 500px;
	overflow: hidden;
}

.slide-enter,
.slide-leave-to {
	overflow: hidden;
	max-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Faq.vue